<template>
  <div class="create">
    <div class="createContent">
      <img src="https://neadoo.pl/wp-content/uploads/2019/07/logo.svg" />
      <div class="content">
        <h1>Create PDF</h1>
        <form action="#" method="POST">
          <input
            type="text"
            v-model="clientName"
            name="client_name"
            placeholder="Client Name"
          />
          <br />
          <label for="audit">Audyt? </label>
          <input
            type="checkbox"
            id="Audit"
            name="Audit"
            value="AuditChecked"
            v-model="AuditChecked"
          />
          <br />

          <label for="audit">SEO? </label>
          <input
            type="checkbox"
            id="SEO"
            name="SEO"
            value="SeoChecked"
            v-model="SeoChecked"
          />
          <br />
          <label for="audit">PPC? </label>
          <input
            type="checkbox"
            id="PPC"
            name="PPC"
            value="PpcChecked"
            v-model="PpcChecked"
          />
          <br />

          <select name="trader_name" v-model="selectedTrader">
            <option
              v-for="trader in traders"
              v-bind:value="trader.name"
              :key="trader.id"
              >{{ trader.name }}</option
            >
          </select>

          <!-- <input type="submit" value="Submit" /> -->
        </form>
        <br /><br />
        <router-link
          :to="{
            name: 'Preview',
            params: {
              clientName: clientName,
              AuditChecked: AuditChecked,
              SeoChecked: SeoChecked,
              PpcChecked: PpcChecked,
              selectedTrader: selectedTrader,
            },
          }"
        >
          Generuj PDF
        </router-link>
        <br /><br />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Create',
  components: {},
  props: [
    'clientName',
    'AuditChecked',
    'SeoChecked',
    'PpcChecked',
    'selectedTrader',
  ],
  data: function () {
    return {
      traders: [
        {
          id: 1,
          name: 'Robert Starecki',
          phone: '+48 111 111 111 ',
          mail: 'rs@neadoo.eu',
          photo: '/traders/robert.jpg',
        },
        {
          id: 2,
          name: 'Krzysztof Marcinkowski',
          phone: '+48 222 222 222',
          mail: 'km@neadoo.eu',
          photo: '/traders/krzysztof.jpg',
        },
      ],
      checkedService: [],
    }
  },
}
</script>

<style lang="scss" scoped>
img {
  // background: #fff;
  margin: 0;
  min-width: 350px;
  padding: 25px 25px 0 25px;
}
.create {
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column wrap;
  min-height: 100vh;
  .createContent {
    max-width: 600px;
    background: #fff;
    box-shadow: 0px -1px 48px 5px rgba(0, 0, 0, 0.4);
    border-radius: 15px;
    .content {
      padding: 40px 75px;
    }
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
